var render, staticRenderFns
import script from "./associated_customers.vue?vue&type=script&lang=js"
export * from "./associated_customers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('846330a8')) {
      api.createRecord('846330a8', component.options)
    } else {
      api.reload('846330a8', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/customer_org/associated/associated_customers/associated_customers.vue"
export default component.exports